/* eslint-disable prettier/prettier */
import { AINotesTypeOfVisitEnum } from 'types';

export const aiNotesTypeOfVisitOptions: Array<{ id: string; value: string; translationKey: string }> = [
  {
    id: AINotesTypeOfVisitEnum.FollowUp.toString(),
    value: 'Follow-up',
    translationKey: 'followUp',
  },
  {
    id: AINotesTypeOfVisitEnum.Consultation.toString(),
    value: 'Consultation',
    translationKey: 'consultation',
  },
  {
    id: AINotesTypeOfVisitEnum.Intake.toString(),
    value: 'Intake',
    translationKey: 'intake',
  },
  {
    id: AINotesTypeOfVisitEnum.Discharge.toString(),
    value: 'Discharge',
    translationKey: 'discharge',
  },
  {
    id: AINotesTypeOfVisitEnum.Termination.toString(),
    value: 'Last/Termination',
    translationKey: 'lastTermination',
  },
  {
    id: AINotesTypeOfVisitEnum.CouplesCounseling.toString(),
    value: 'Couples Counseling',
    translationKey: 'couplesCounseling',
  },
  {
    id: AINotesTypeOfVisitEnum.FamilyTherapy.toString(),
    value: 'Family Therapy',
    translationKey: 'familyTherapy',
  },
  {
    id: AINotesTypeOfVisitEnum.ChildTherapy.toString(),
    value: 'Child Therapy',
    translationKey: 'childTherapy',
  },
  {
    id: AINotesTypeOfVisitEnum.IndividualTherapy.toString(),
    value: 'Individual Therapy',
    translationKey: 'individualTherapy',
  },
  {
    id: AINotesTypeOfVisitEnum.GroupTherapy.toString(),
    value: 'Group Therapy',
    translationKey: 'groupTherapy',
  },
];
